import { useMemo } from "react";
import { Status } from "../../../enums/status";
export function useOrderProgressState({ status }) {
    const percentage = useMemo(() => {
        switch (status) {
            case Status.ORDER_PLACED:
                return 0;
            case Status.PROCESSING:
            case Status.OPEN:
                return 33;
            case Status.PACKED:
                return 34;
            case Status.READY:
                return 66;
            case Status.DELIVERY:
            case Status.IN_TRANSIT:
                return 67;
            case Status.DELIVERED:
            case Status.FULFILLED:
                return 100;
            default:
                return 0;
        }
    }, [status]);
    return useMemo(() => ({
        percentage,
    }), [percentage]);
}
